// extracted by mini-css-extract-plugin
export default {"expandable_text":"expandable_text__bb270a40","text":"text__bb270a40","expandable_button":"expandable_button__bb270a40","show":"show__bb270a40"};